import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { type ClockLocationInput, clockIn } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { NO_LOCATION_MESSAGE, timeEntryErrorMessage } from "../utils/format";
import { invalidateAttendance } from "./invalidate-attendance";

export function useClockIn() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (location: ClockLocationInput | null) =>
			clockIn(activeCanteiroId as string, location),
		onSuccess: (_entry, location) => {
			invalidateAttendance(queryClient);
			toast.success("Entrada registrada", {
				description: location ? undefined : NO_LOCATION_MESSAGE,
			});
		},
		onError: (err) => {
			toast.error(
				timeEntryErrorMessage(err, "Não foi possível registrar a entrada."),
			);
		},
	});
}
